import { render } from "./SalmonIcon.vue?vue&type=template&id=060b5b5a&bindings={}"
import script from "./SalmonIcon.vue?vue&type=script&lang=js"
export * from "./SalmonIcon.vue?vue&type=script&lang=js"
script.render = render

export default script